import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, Clock } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import SEO from '../components/SEO';
import { blogPosts } from '../data/blogPosts';
import { getPublicBlogs } from '../utils/api';

const formatDate = (d) => new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' });

const BlogPage = () => {
  const [posts, setPosts] = useState(blogPosts);

  useEffect(() => {
    getPublicBlogs()
      .then((dbPosts) => {
        const staticSlugs = new Set(blogPosts.map((p) => p.slug));
        const merged = [...blogPosts, ...(dbPosts || []).filter((p) => !staticSlugs.has(p.slug))];
        merged.sort((a, b) => new Date(b.date) - new Date(a.date));
        setPosts(merged);
      })
      .catch(() => {});
  }, []);

  return (
    <div data-testid="blog-index-page">
      <SEO
        title="Blog | Mutual Fund & SIP Insights | Rubicon Finservices"
        description="Practical guides on SIPs, mutual funds and financial planning from Rubicon Finservices, an AMFI-registered mutual fund distributor in Kolkata."
        keywords="mutual fund blog, SIP guide, investing Kolkata, financial planning articles, Rubicon Finservices blog"
        ogImage="https://customer-assets.emergentagent.com/job_rubicon-funds/artifacts/7akuxub4_LOGO.png"
      />
      <section className="bg-gradient-to-br from-blue-900 via-blue-800 to-purple-900 text-white py-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="inline-block bg-amber-500/20 text-amber-300 px-4 py-1.5 rounded-full text-sm font-semibold mb-4">Blog & Resources</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4">Insights for Everyday Investors</h1>
          <p className="text-base md:text-lg text-blue-100">Plain-language guides on SIPs, mutual funds and planning, written by our team in Kolkata.</p>
        </div>
      </section>

      <section className="py-16 bg-slate-50">
        <div className="container mx-auto px-4 max-w-4xl space-y-6">
          {posts.map((post) => (
            <Link key={post.slug} to={`/blog/${post.slug}`} className="group block" data-testid={`blog-card-${post.slug}`}>
              <Card className="border-2 border-slate-200 hover:border-amber-500 hover:shadow-xl transition-all duration-300">
                <CardContent className="p-8">
                  <div className="flex flex-wrap items-center gap-4 text-sm text-slate-500 mb-3">
                    <span className="bg-amber-100 text-amber-700 px-3 py-1 rounded-full font-semibold text-xs">{post.category}</span>
                    <span className="flex items-center gap-1"><Calendar size={14} /> {formatDate(post.date)}</span>
                    <span className="flex items-center gap-1"><Clock size={14} /> {post.readTime}</span>
                  </div>
                  <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-3 group-hover:text-amber-600 transition-colors">{post.title}</h2>
                  <p className="text-slate-600 mb-5">{post.excerpt}</p>
                  <span className="inline-flex items-center gap-2 text-amber-600 font-semibold group-hover:gap-3 transition-all">
                    Read Article <ArrowRight size={18} />
                  </span>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default BlogPage;
